const updateWithinCollection = (
  collection,
  action,
  reducer,
  actionIdKey = 'id',
  elementIdKey = 'id'
) => {
  const actionId = action[actionIdKey];
  if (actionId !== undefined) {
    const oldElement = collection.find(element => element[elementIdKey] === actionId);
    if (oldElement) {
      const newElement = reducer(oldElement, action);
      if (newElement !== oldElement) {
        return collection.map(element =>
          element[elementIdKey] === actionId ? newElement : element
        );
      }
    }
  }
  return collection;
};

export { updateWithinCollection };

export default function combineCollectionReducers(collectionReducer, elementReducer) {
  return (state = collectionReducer(undefined, { type: null }), action) => {
    const newState = updateWithinCollection(state, action, elementReducer);
    return collectionReducer(newState, action);
  };
}
